var exports = {
  "k": "container__r22cll",
};

module.exports = exports;
